module.exports = __webpack_public_path__ + "static/media/detail_0023_t.69cd732f.jpg";